import React from 'react';
import { Row, Col, Divider } from 'antd';
import Banner from './Banner';
import BannerCurve from './BannerCurve';
import Features from './FeatureSection';
import ContentSection from './ContentSection';
import ContentCurve from './ContentCurve';
import ContentFinalCall from './ContentFinalCall';
import Footer from './Footer';

import contentImage1 from './images/content-image-1.png';
import contentImage2 from './images/content-image-2.png';
import contentImage3 from './images/content-image-3.png';
import PremiumSection from '../Premium/PremiumSection';
import PremiumCurve from '../Premium/PremiumCurve';
import { app } from '../../../Config';
import HelmetSeo from '../../../Assets/Utilities/HelmetSeo';

const LangingPage = () => {
  return (
    <div>
      <HelmetSeo
        title='Interact | Stay Private, together!'
        description='Stay upto date with friends, followers and Global family, start exploring! The only way to use social media stress free - Express yourself!'
        url={`${app}`}
        image={`${app}/images/icons/new-icon-512x512.png`}
      />
      <Row className='landing-page-wrapper'>
        <Col xs={24}>
          {/* Banner */}
          <Banner />
          <BannerCurve />
          <Features />
          <ContentSection
            image={contentImage1}
            title='Share every moment'
            description="You don't have to feel lonely anymore, 
                                    take a moment to convey your emotions with people who care about you,
                                    help them understand things you are not confortable taking about."
            orderImage={1}
            orderContent={2}
            imageOffset={2}
            contentOffset={2}
            background='#F8F8F8'
          />
          <ContentSection
            image={contentImage2}
            title='Never miss a thing'
            description='Every moment is captured for you to feel and understand, 
                                    catchup with your friends and people you care about,
                                    help them in their tough times, engage with them when they need you.'
            orderImage={2}
            orderContent={1}
            imageOffset={2}
            contentOffset={2}
            background='#F8F8F8'
          />
          <ContentCurve />
          <ContentSection
            image={contentImage3}
            title='Boost yourself and your productivity'
            description="There are only so many hours in the day, 
                                    so making the most of your time is critical.
                                    Being more productive isn't rocket science, 
                                    but it does require being more deliberate about how you manage your time."
            orderImage={1}
            orderContent={2}
            imageOffset={2}
            contentOffset={2}
            background='#fefdfd'
          />
          {/* <PremiumCurve />
                    <PremiumSection /> */}
          <ContentFinalCall />
          <Divider />
          <Footer />
        </Col>
      </Row>
    </div>
  );
};

export default LangingPage;
